<div class="chart-section">
  <div class="section-header">
    <div class="section-icon location">
      <i class="bi bi-geo-alt"></i>
    </div>
    <h2 class="section-title">
      Followers Location
      <a class="info-tip" data-tooltip="The profile is most popular among people from those places">
        <i class="bi bi-info-circle"></i>
      </a>
    </h2>
  </div>

  <div class="section-card">
    <!-- Tabs -->
    <div class="section-tabs" *ngIf="+type() === 1">
      <button class="tab active">
        <i class="bi bi-people"></i> Followers
      </button>
    </div>

    <!-- Loading -->
    <app-loader *ngIf="!(profileState | async).loader['audit']['audienceLocation']" size="sm" message="Loading locations..."></app-loader>

    <div [class.dimmed]="!(profileState | async).loader['audit']['audienceLocation']" *ngIf="chartsLocation !== undefined">
      <div class="chart-grid">
        <!-- Cities -->
        <div class="chart-cell" [ngClass]="!(profileState | async).boxExampleStatus[sectionName.city] && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''">
          <app-audit-example [name]="sectionName.city">
            <div class="chart-cell-header">
              <h3>
                <i class="bi bi-buildings cell-icon text-blue"></i>
                Cities
                <a class="info-tip" data-tooltip="Popular cities among followers"><i class="bi bi-info-circle"></i></a>
              </h3>
            </div>
            <div>
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.city"></app-audit-placeholder>
              <div [chart]="chartsLocation[0]"></div>
            </div>
          </app-audit-example>
        </div>

        <!-- Countries -->
        <div class="chart-cell" [ngClass]="!(profileState | async).boxExampleStatus[sectionName.country] && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''">
          <app-audit-example [name]="sectionName.country">
            <div class="chart-cell-header">
              <h3>
                <i class="bi bi-globe2 cell-icon text-green"></i>
                Countries
                <a class="info-tip" data-tooltip="Popular countries among followers"><i class="bi bi-info-circle"></i></a>
              </h3>
            </div>
            <div>
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.country"></app-audit-placeholder>
              <div [chart]="chartsLocation[1]"></div>
            </div>
          </app-audit-example>
        </div>
      </div>
    </div>
  </div>
</div>